import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-upload', 'upload', 'Įkelti');
Labels.set('ui-upload', 'uploadFiles', 'Įkelti failus');
Labels.set('ui-upload', 'clear', 'Pašalinti failą');
